import { useEffect, useState } from "react";

export function useLocalStorage<T>(key: string, initialValue: T | (() => T)) {
    const [value, setValueInternal] = useState<T>(() => {
        const jsonValue = localStorage.getItem(key)
        if (jsonValue == null) {
            if (typeof initialValue === "function") {
                return (initialValue as () => T)()
            } else {
                return initialValue
            }
        } else {
            return JSON.parse(jsonValue);
        }
    })

    function setValue(val: T) {
        setValueInternal(x => val)
        localStorage.setItem(key, JSON.stringify(val))
    }

    return [value, setValue] as [T, typeof setValue]
}
